module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "configbar"
  }, [_c('div', {
    attrs: {
      "align": "left"
    }
  }, [(_vm.$auth.user().roles[0].name === 'department-responsible' && _vm.selectedDepartment) ? _c('div', [_c('b', [_vm._v(_vm._s(_vm.selectedDepartment.name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('i', [_vm._v("Logget ind som afdelingsansvarlig")])]) : _c('div', [(_vm.selectedDepartment !== null) ? _c('dropdown', {
    attrs: {
      "options": _vm.departments,
      "selected": _vm.selectedDepartment,
      "placeholder": 'Vælg afdeling',
      "closeOnOutsideClick": true
    },
    on: {
      "updateOption": _vm.selectDepartment
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "date-range"
  }, [_c('div', {
    staticClass: "flex"
  }, [_vm._m(0), _vm._v(" "), _c('datepicker', {
    staticClass: "date-picker",
    attrs: {
      "monday-first": "",
      "language": _vm.datepickerLocale,
      "placeholder": "Startdato"
    },
    model: {
      value: (_vm.$store.state.config.startDate),
      callback: function($$v) {
        _vm.$set(_vm.$store.state.config, "startDate", $$v)
      },
      expression: "$store.state.config.startDate"
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('datepicker', {
    staticClass: "date-picker",
    attrs: {
      "monday-first": "",
      "language": _vm.datepickerLocale,
      "placeholder": "Slutdato"
    },
    model: {
      value: (_vm.$store.state.config.endDate),
      callback: function($$v) {
        _vm.$set(_vm.$store.state.config, "endDate", $$v)
      },
      expression: "$store.state.config.endDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "custom-time-period"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedTimePeriod),
      expression: "selectedTimePeriod"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedTimePeriod = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.selectTimePeriod($event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "Vælg tidsinterval",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Vælg tidsinterval ↓")]), _vm._v(" "), _vm._l((_vm.customTimeIntervals), function(timeInterval, index) {
    return _c('option', {
      key: index,
      attrs: {
        "startDate": 2019,
        "endDate": 2020
      },
      domProps: {
        "value": timeInterval.name
      }
    }, [_vm._v("\n                    " + _vm._s(timeInterval.name) + "\n                ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "smart",
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    staticClass: "options reversed"
  }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.$store.state.config.availableAccountingYears), function(accountingYear, index) {
    return (index < 3) ? _c('div', {
      key: accountingYear.year,
      staticClass: "single-option",
      class: {
        'selected': accountingYear.from_date === _vm.$store.getters.getStartDate && accountingYear.to_date === _vm.$store.getters.getEndDate
      },
      on: {
        "click": function($event) {
          return _vm.selectAccountingYear(accountingYear)
        }
      }
    }, [_vm._v("\n                " + _vm._s(accountingYear.year) + "\n            ")]) : _vm._e()
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_c('b', [_vm._v("Vælg periode:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "fal fa-chevron-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "white-space": "nowrap",
      "margin-right": "30px"
    }
  }, [_c('b', [_vm._v("Vælg regnskabsår:")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2631a998", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2631a998"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/ConfigBar.vue
// module id = 802
// module chunks = 0